import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { MessageService } from '@corelabs/angular/messages';
import { TranslateService } from '@ngx-translate/core';
import { catchError, throwError } from 'rxjs';
import { SKIP_ERROR_MESSAGE } from '../http-context';

export const apiErrorMessageInterceptor: HttpInterceptorFn = (req, next) => {
    if (req.context.get(SKIP_ERROR_MESSAGE)) {
        return next(req);
    }

    const messageService = inject(MessageService);
    const translateService = inject(TranslateService);

    return next(req).pipe(
        catchError((response: HttpErrorResponse) => {
            // API error envelope is `{ error: { code, message } }`, where `code` is one of `GET /api/v1/error-codes`.
            const errorCode = response.error?.error?.code;

            // 401s belong to the auth pipeline — the outer refresh interceptor still replays them.
            if (errorCode && response.status !== 401) {
                const translationKey = `error.${errorCode.replaceAll('_', '-')}`;
                // `instant` echoes the key back when there's no entry for it.
                const translated = translateService.instant(translationKey);
                const message = translated === translationKey ? translateService.instant('error.generic') : translated;

                messageService.add(message, 'danger');
            }

            return throwError(() => response);
        }),
    );
};
